export default __webpack_public_path__ + "static/media/rightarrow.7dbef3c8.svg";